/**
 * WeekGrid — 7-column (Mon–Sun) week layout.
 *
 * Props:
 *   weekStart   {Date}    Monday of the displayed week
 *   sessionsByDay {Object} { '0': [...], ... '6': [...] } from mapSessionsToWeek
 *   onSessionClick {(session)=>void}
 */

import { getWeekDays, toDateString, WEEK_DAY_LABELS } from '../../utils/weekMapping';
import SessionBlock from './SessionBlock';

const WeekGrid = ({ weekStart, sessionsByDay, onSessionClick }) => {
  const days = getWeekDays(weekStart);
  const todayStr = toDateString(new Date());

  return (
    <div className="overflow-x-auto">
      <div
        className="grid min-w-[700px]"
        style={{ gridTemplateColumns: 'repeat(7, minmax(0, 1fr))' }}
        role="grid"
        aria-label="Calendrier hebdomadaire"
      >
        {/* Day headers */}
        {days.map((day, idx) => {
          const dateStr = toDateString(day);
          const isToday = dateStr === todayStr;
          return (
            <div
              key={idx}
              className={[
                'px-2 py-2 text-center border-b border-gray-200',
                isToday ? 'bg-[#EAF4FB]' : 'bg-gray-50',
              ].join(' ')}
              role="columnheader"
            >
              <p className={`text-xs font-montserrat font-semibold uppercase tracking-wide ${isToday ? 'text-[#17386E]' : 'text-[#4A4A4A]'}`}>
                {WEEK_DAY_LABELS[idx]}
              </p>
              <p className={`text-lg font-montserrat font-bold mt-0.5 ${isToday ? 'text-[#17386E]' : 'text-[#4A4A4A]'}`}>
                {day.getDate()}
              </p>
            </div>
          );
        })}

        {/* Session cells */}
        {days.map((day, idx) => {
          const dateStr = toDateString(day);
          const isToday = dateStr === todayStr;
          const daySessions = sessionsByDay[idx] ?? [];

          return (
            <div
              key={idx}
              className={[
                'p-2 min-h-[120px] border-r border-gray-100 align-top',
                isToday ? 'bg-[#EAF4FB]/30' : 'bg-white',
                idx === 6 ? 'border-r-0' : '',
              ].join(' ')}
              role="gridcell"
            >
              {daySessions.length === 0 ? (
                <p className="text-xs text-gray-300 text-center mt-4">—</p>
              ) : (
                daySessions.map((session) => (
                  <SessionBlock
                    key={`${session.contract_id}-${session.id}`}
                    session={session}
                    onClick={() => onSessionClick(session)}
                  />
                ))
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeekGrid;
